import { render, staticRenderFns } from "./DetailBillByStudent.vue?vue&type=template&id=35c97428&scoped=true&"
import script from "./DetailBillByStudent.vue?vue&type=script&lang=js&"
export * from "./DetailBillByStudent.vue?vue&type=script&lang=js&"
import style0 from "./DetailBillByStudent.vue?vue&type=style&index=0&id=35c97428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c97428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTab,VTabItem,VTabs,VTabsItems,VTextarea})
